<script setup lang="ts">
import { defineProps, defineEmits, onMounted, onUnmounted } from 'vue';

const props = defineProps<{
  show: boolean;
  type: 'success' | 'error' | 'info' | 'warning';
  title: string;
  message: string;
}>();

const emit = defineEmits(['close']);

const close = () => emit('close');
</script>

<template>
  <Transition name="fade">
    <div v-if="show" class="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <!-- Backdrop -->
      <div 
        class="absolute inset-0 bg-black/80 backdrop-blur-sm transition-opacity"
        @click="close"
      ></div>

      <!-- Modal -->
      <div 
        class="relative bg-surface border border-white/10 rounded-2xl w-full max-w-md p-6 shadow-2xl transform transition-all animate-in zoom-in-95 duration-200"
        role="dialog"
      >
        <!-- Icon -->
        <div class="flex justify-center mb-4">
          <div 
            v-if="type === 'error'"
            class="w-16 h-16 rounded-full bg-red-500/20 flex items-center justify-center"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-red-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
          </div>
          <div 
            v-else-if="type === 'success'"
            class="w-16 h-16 rounded-full bg-green-500/20 flex items-center justify-center"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-green-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
          </div>
          <div 
            v-else
            class="w-16 h-16 rounded-full bg-blue-500/20 flex items-center justify-center"
          >
             <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-blue-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
          </div>
        </div>

        <h3 class="text-2xl font-bold text-white text-center mb-2">{{ title }}</h3>
        <p class="text-gray-400 text-center mb-6">{{ message }}</p>

        <button 
          @click="close"
          class="w-full py-3 rounded-xl font-bold transition-all text-white"
          :class="type === 'error' ? 'bg-red-600 hover:bg-red-500' : 'bg-surface border border-white/20 hover:bg-white/10'"
        >
          {{ type === 'error' ? 'Entendido' : 'Continuar' }}
        </button>

        <button 
          @click="close"
          class="absolute top-4 right-4 text-gray-500 hover:text-white"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
